<div class="component-compass">
	<div class="scale" style="{{rotationStyle}}">
		<div class="directions">
			<span class="north">N</span>
			<span class="east">E</span>
			<span class="south">S</span>
			<span class="west">W</span>
		</div>
	</div>
	<div class="info">
		<div class="info-wrapper">
			<div class="direction">{{direction}}</div>
			<div class="angle">{{angle}}</div>
		</div>
	</div>
</div>

<script>
	import './compass.css'
	import compass from '../../services/compass.service.js'

	export default {
		data() {
			return {
				heading: 0,
				direction: 'X'
			}
		},
		oncreate() {
			var component = this
			compass.subscribe(function({ alpha, heading, direction }){
				component.set({ alpha, heading, direction })
			})
		},
		ondestroy() {
			
		},
		computed: {
			rotationStyle(alpha) {
				return 'transform: rotateZ(' + alpha + 'deg)'
			},
			angle(heading) {
				var angle = parseInt(heading, 10)
				return angle
			}
		}
	}

</script>


// WEBPACK FOOTER //
// ./src/components/compass/compass.html